import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivCreateOutboundInvoiceDocumentDtoGen,
  MrfiktivInvoiceControllerCreatePayloadGen,
  MrfiktivInvoiceControllerGetParamsGen,
  MrfiktivInvoiceControllerUpdatePayloadGen
} from "../v1/data-contracts";
import { Invoice } from "../v1/Invoice";

/**
 * Communicate with invoice API
 */
class InvoiceService {
  mrfiktivProxy: Invoice;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new Invoice(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create aninvoice
   */
  async create(partnerId: string, data: MrfiktivInvoiceControllerCreatePayloadGen) {
    const invoice = (await this.mrfiktivProxy.invoiceControllerCreate(partnerId, data)).data;

    return invoice;
  }

  /**
   * Get allinvoice
   */
  async get(data: MrfiktivInvoiceControllerGetParamsGen) {
    const Invoices = (await this.mrfiktivProxy.invoiceControllerGet(data)).data;

    return Invoices;
  }

  /**
   * Get an invoice
   */
  async getOne(partnerId: string, invoiceId: string) {
    const invoice = (await this.mrfiktivProxy.invoiceControllerGetOne(partnerId, invoiceId)).data;

    return invoice;
  }

  /**
   * Update an invoice
   */
  async update(partnerId: string, invoiceId: string, data: MrfiktivInvoiceControllerUpdatePayloadGen) {
    const invoice = (await this.mrfiktivProxy.invoiceControllerUpdate(partnerId, invoiceId, data)).data;

    return invoice;
  }

  /**
   * Delete an invoice
   */
  async delete(partnerId: string, invoiceId: string) {
    const invoice = (await this.mrfiktivProxy.invoiceControllerDelete(partnerId, invoiceId)).data;

    return invoice;
  }

  /**
   * Print the invoice. Set status to created.
   * @param partnerId
   * @param invoiceId
   * @returns
   */
  async print(partnerId: string, invoiceId: string) {
    const invoice = (await this.mrfiktivProxy.invoiceControllerCreatePdf(partnerId, invoiceId)).data;

    return invoice;
  }

  /**
   * Add document to the invoice. Set status to created.
   * @param partnerId
   * @param invoiceId
   * @param data
   * @returns
   */
  async addDocument(partnerId: string, invoiceId: string, data: MrfiktivCreateOutboundInvoiceDocumentDtoGen) {
    const invoice = (await this.mrfiktivProxy.invoiceControllerAddDocument(partnerId, invoiceId, data)).data;

    return invoice;
  }

  /**
   * Preview the PDF of the invoice
   * @param partnerId
   * @param invoiceId
   * @returns
   */
  async generatePdfPreview(partnerId: string, invoiceId: string): Promise<Buffer> {
    const bufferObject = (await this.mrfiktivProxy.invoiceControllerGetPdf(partnerId, invoiceId)).data;

    return Buffer.from(Object.values(bufferObject));
  }
}

/**
 * Communicate with invoice API
 */
export default new InvoiceService(new MrfiktivHttpClientProvider());
